module.exports = __webpack_public_path__ + "static/media/painting_studio_logos.cecb1ab0.webp";